/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * Bundle object
 */

// required attributes
const BundleR = t.interface({});

// optional attributes
const BundleO = t.partial({
  abi: t.string,

  bundleDescription: t.string,

  bundleName: t.string,

  idBrokerPsp: t.string,

  idBundle: t.string,

  idChannel: t.string,

  idPsp: t.string,

  onUs: t.boolean,

  paymentMethod: t.string,

  taxPayerFee: t.Integer,

  touchpoint: t.string,

  pspBusinessName: t.string
});

export const Bundle = t.intersection([BundleR, BundleO], "Bundle");

export type Bundle = t.TypeOf<typeof Bundle>;
